import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import CardContent from "@mui/material/CardContent";
import { Modal, Button } from "@mui/material";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import { LazyLoadImage } from "react-lazy-load-image-component";
import BookmarkAddedIcon from "@mui/icons-material/BookmarkAdded";
import { useTranslation } from "react-i18next";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  border: "none",
  outline: "none",
};
const Media = ({ prod }) => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  const [open1, setOpen1] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const [open3, setOpen3] = React.useState(false);
  const handleOpen1 = () => setOpen1(true);
  const handleClose = () => {
    setOpen1(false);
    setOpen2(false);
    setOpen3(false);
  };

  return (
    <>
      <div
        style={{
          width: "100%",
          height: "400px",
          color: "#424242",
          backgroundRepeat: "none",
          backgroundSize: "cover",
          backgroundPosition: "right 15% bottom 65%",
          // backgroundImage: `url("https://images.unsplash.com/photo-1469050624972-f03b8678e363?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80")`,
          // backgroundImage: `url("https://images.unsplash.com/photo-1586162544865-6878ac726bba?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80")`,
          backgroundImage: `url("https://images.unsplash.com/photo-1596263373793-6de9aa1b6a53?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80")`,
          display: "flex",
          alignItems: "center",
        }}
      >
        <Box sx={{ fontSize: "20px", pl: 10 }}>
          <Typography
            sx={{ display: "flex", alignItems: "center", fontSize: "23px" }}
          >
            <BookmarkAddedIcon sx={{ color: "#36b4e6" }} />
            <Box sx={{ pt: 1, pl: 1 }}>{t("media_title")}</Box>
          </Typography>
        </Box>
      </div>
      <Box className={classes.product__inner}>
        <Grid container sx={{ width: 1, pt: 5 }}>
          <Grid item md={12}>
            <Typography variant="h4" className="title">
              {t("Media")}
            </Typography>
            <Typography color="gray" sx={{ pb: 4 }}>
              {t("media_exp")}
            </Typography>
          </Grid>
          <Grid item md={4} sm={12} onClick={() => setOpen1(true)}>
            <Grid
              container
              className={classes.product__content}
              sx={{
                paddingTop: "20px",
                flexDirection: "column",
              }}
            >
              <Grid item sx={{ width: 3 / 4 }}>
                <LazyLoadImage
                  className={classes.product__img}
                  height="130"
                  width="100"
                  alt={process.env.PUBLIC_URL + "/img/squid.png"}
                  src={process.env.PUBLIC_URL + "/img/squid.png"}
                  style={{ borderRadius: "20px", border: "1px solid #e0e0e0" }}
                />
              </Grid>
              <Grid
                item
                sx={{
                  width: 3 / 4,
                }}
              >
                <CardContent>
                  <Typography
                    sx={{ fontSize: 14 }}
                    color="text.secondary"
                    gutterBottom
                  >
                    Heslet
                  </Typography>
                  <Typography
                    variant="h5"
                    component="div"
                    sx={{ fontWeight: "bold", fontSize: "23px" }}
                  >
                    {t("squid")}
                  </Typography>
                  <Typography color="text.secondary">{t("squid2")}</Typography>
                </CardContent>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={4} sm={12} onClick={() => setOpen2(true)}>
            <Grid
              container
              className={classes.product__content}
              sx={{ paddingTop: "20px", flexDirection: "column" }}
            >
              <Grid item sx={{ width: 3 / 4 }}>
                <LazyLoadImage
                  className={classes.product__img}
                  height="130"
                  width="160"
                  alt={process.env.PUBLIC_URL + "/img/avengers.png"}
                  src={process.env.PUBLIC_URL + "/img/avengers.png"}
                  style={{ borderRadius: "20px", border: "1px solid #e0e0e0" }}
                />
              </Grid>
              <Grid item sx={{ width: 3 / 4 }}>
                <CardContent>
                  <Typography
                    sx={{ fontSize: 14 }}
                    color="text.secondary"
                    gutterBottom
                  >
                    Heslet
                  </Typography>
                  <Typography
                    variant="h5"
                    component="div"
                    sx={{ fontWeight: "bold", fontSize: "23px" }}
                  >
                    {t("avengers")}
                  </Typography>
                  <Typography color="text.secondary">
                    {t("avengers2")}
                  </Typography>
                </CardContent>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={4} sm={12} onClick={() => setOpen3(true)}>
            <Grid
              container
              className={classes.product__content}
              sx={{ paddingTop: "20px", flexDirection: "column" }}
            >
              <Grid item sx={{ width: 3 / 4 }}>
                <LazyLoadImage
                  className={classes.product__img}
                  height="130"
                  width="160"
                  alt={process.env.PUBLIC_URL + "/img/media_03.png"}
                  src={process.env.PUBLIC_URL + "/img/media_03.png"}
                  style={{ borderRadius: "20px", border: "1px solid #e0e0e0" }}
                />
              </Grid>
              <Grid item sx={{ width: 3 / 4 }}>
                <CardContent>
                  <Typography
                    sx={{ fontSize: 14 }}
                    color="text.secondary"
                    gutterBottom
                  >
                    Heslet
                  </Typography>
                  <Typography
                    variant="h5"
                    component="div"
                    sx={{ fontWeight: "bold", fontSize: "23px" }}
                  >
                    {t("squid_game")}
                  </Typography>
                  <Typography color="text.secondary">
                    {t("squid_game2")}
                  </Typography>
                </CardContent>
              </Grid>
            </Grid>
          </Grid>

          <Modal
            open={open1}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <iframe
                width="800"
                height="500"
                src="https://www.youtube.com/embed/w1WPg8ARvZM?autoplay=1"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </Box>
          </Modal>
          <Modal
            open={open2}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <iframe
                width="800"
                height="500"
                src="https://www.youtube.com/embed/nI-XewRyRFg?autoplay=1"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </Box>
          </Modal>
          <Modal
            open={open3}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <iframe
                width="800"
                height="500"
                src="https://www.youtube.com/embed/5RFHLaLfqWA?autoplay=1"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </Box>
          </Modal>
        </Grid>
      </Box>
    </>
  );
};

export default Media;

const useStyles = makeStyles({
  product: {},
  product__inner: {
    padding: "30px",
    textAlign: "center",
    paddingTop: "20px",
  },
  product__content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: "70px",
  },
  product__img: {
    maxWidth: "500px",
    minWidth: "200px",
    borderRadius: "2%",
    cursor: "pointer",
  },
});
